import Style from "./AdminDetailStyle";
import api from "../../services/api";
import { useState, useEffect } from "react";
import Spinner from "../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import PageTitle from "../../components/PageTitle";


export default function CreateEditAdmin(props) {
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [job, setJob] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [successMessage, setSuccessMessage] = useState<string>();
  const [showPopup, setShowPopup] = useState(false);
  const accountId: number = props.match.params.accountId;
  const creatingNew = accountId <= 0;


  useEffect(() => {
    if (!creatingNew) {
      LoadAdmin(accountId);
    }
  }, []);

  async function LoadAdmin(accountId) {
    try {
      const result = await api.get(`/admin/${accountId}`);
      if (result.data.success) {
        let admin = result.data.admin;
        setId(admin.id)
        setName(admin.name);
        setEmail(admin.email);
        setJob(admin.job);
      }
    } catch (error) {
      console.error("Erro ao buscar o admin selecionado: ", error);
    }
  }


  function OnSubmit() {
    if (creatingNew) {
      onCreate()
    } else {
      onEdit()
    }
  }

  async function onCreate() {
    try {
      setLoading(true);
      const data = {
        name, email: email.toLowerCase(), password, job, acceptedLGPD: true,
      }
      const request = api.post(`/admin/create`, data);
      const result = await request;
      setSuccessMessage("Criou admin com sucesso, id: " + result.data.adminId);
      onClosePopup();
      setLoading(false);
      props.history.push('/admin')
    }
    catch (error: any) {
      setLoading(false);
      onClosePopup();
      setErrorMessage(error?.response?.data?.message);
    }
  }

  async function onEdit() {
    try {
      setLoading(true);
      const data = {
        id, name, email, job, accountId, acceptedLGPD: true,
      }
      const request = api.put(`/admin/edit`, data);
      const result = await request;
      setSuccessMessage("Editou admin com sucesso, id: " + result.data.adminId);
      setErrorMessage("");
      onClosePopup();
      setLoading(false);
      props.history.goBack()
    }
    catch (error: any) {
      setLoading(false);
      onClosePopup();
      setErrorMessage(error?.response?.data?.message);
    }
  }
  function onOpenPopUp() {
    setShowPopup(true);
  }

  function onClosePopup() {
    setShowPopup(false);
  }

  return (
    <Style>
      <PageTitle title="Detalhes do Admin" />
      <div>
        <TwoButtonsModal
          show={showPopup}
          onHide={onClosePopup}
          loading={loading}
          title="Deleção de admin!"
          body={"Você tem certeza que deseja" + (creatingNew ? " cadastrar este admin?" : " editar este admin?")}
          secondaryText="Fechar"
          secondaryOnClick={onClosePopup}
          secondaryDisabled={loading}
          primaryText="Confirmar"
          primaryOnClick={() => OnSubmit()}
          primaryDisabled={loading}
        />
        <div>
          <button onClick={() => props.history.goBack()} className="btn btn-secondary">Voltar</button>
        </div>
        <Spinner spinning={loading} />
        {errorMessage && <p className="alert alert-danger">Erro: {errorMessage}</p>}
        {successMessage && <p className="alert alert-info">{successMessage}</p>}
        <main>
          <div className="panel">
            <form className="main-form" onSubmit={(e) => { e.preventDefault(); }}>
              <h2>Cadastro de administradores</h2>
              <div>
                <label>Nome: </label>
                <input

                  disabled={loading}
                  defaultValue={name}
                  onChange={e => setName(e.target.value)}
                />
              </div>
              <div>
                <label>Email: </label>
                <input

                  disabled={loading}
                  value={email || ""}
                  onChange={e => setEmail(e.target.value)}
                />
              </div>
              <div>
                <label>Senha: </label>
                <input
                  type="password"

                  disabled={loading}
                  value={password || ""}
                  onChange={e => setPassword(e.target.value)}
                />
              </div>

              <div>
                <label>Cargo: </label>
                <input

                  disabled={loading}
                  value={job || ""}
                  onChange={e => setJob(e.target.value)}
                />
              </div>
              <button
                className="btn btn-success btn-lg mt-4"
                type="button"
                disabled={loading}
                onClick={e => { e.preventDefault(); onOpenPopUp(); }}>
                {creatingNew ? "Adicionar" : "Editar"}
              </button>
            </form>
          </div>
        </main>
      </div>
    </Style >
  );
}